import OnlinePaymentOrderItemResourceModel from '../../generated/types/model/resource/OnlinePaymentOrderItemResourceModel';

export default class OnlinePaymentOrderItemResourceViewModel extends OnlinePaymentOrderItemResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
